import React, { useRef } from 'react';
import images from '../../themes/appImage';
import { useDispatch } from 'react-redux';
import { uploadAvatarLoad } from '../../redux/slices/setting.slice';

const UploadAvatar = () => {
    const maleInputRef = useRef(null);
    const femaleInputRef = useRef(null);
    const dispatch = useDispatch();

    const handleUploadClick = (inputRef) => {
        inputRef.current.click();
    };

    const handleFileChange = (event, inputRef, avatarType) => {
        const files = event.target.files;
        if (files.length === 0) return;
        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('avatar', files[i]);
        }
        formData.append('avatarType', avatarType);
        dispatch(uploadAvatarLoad(formData));
    };

    return (
        <div className="setting-page-section">
            <div className="avatars-setting-page">
                <h1 className="avatars-titles">Male Avatars</h1>
                <div className="upload-avatars-icons-sett">
                    <div className="no-avatars">
                        <h1>No Avatar Yet!</h1>
                        <button onClick={() => handleUploadClick(maleInputRef)}>
                            <img src={images.whiteUplodeIcon} alt="whiteUplodeIcon" />
                            Upload Avatar
                        </button>
                        <input
                            type="file"
                            ref={maleInputRef}
                            multiple
                            style={{ display: 'none' }}
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => handleFileChange(e, maleInputRef, "male")}
                        />
                    </div>
                </div>
            </div>

            <div className="avatars-setting-page">
                <h1 className="avatars-titles">Female Avatars</h1>
                <div className="upload-avatars-icons-sett">
                    <div className="no-avatars">
                        <h1>No Avatar Yet!</h1>
                        <button onClick={() => handleUploadClick(femaleInputRef)}>
                            <img src={images.whiteUplodeIcon} alt="whiteUplodeIcon" />
                            Upload Avatar
                        </button>
                        <input
                            type="file"
                            ref={femaleInputRef}
                            multiple
                            style={{ display: 'none' }}
                            accept=".png, .jpg, .jpeg"
                            onChange={(e) => handleFileChange(e, femaleInputRef, "female")}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadAvatar;
